module.exports = __webpack_public_path__ + "static/media/lightning.d8850505.svg";